export default __webpack_public_path__ + "static/media/jcb-card.24c29609.svg";